import { useId } from "react";

/**
 * The mark: three vertical lines — a column written top to bottom, the way
 * Japanese is set — and, bottom left where a calligrapher places it, the
 * vermilion seal. "The expert's column, released under their seal."
 */
export function BrandMark({ size = 36, tone = "ink" }: { size?: number; tone?: "ink" | "light" }) {
  const id = useId().replace(/:/g, "");
  const light = tone === "light";
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} aria-hidden className="shrink-0">
      <defs>
        <linearGradient id={`bm-${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={light ? "#ffffff" : "#24406c"} stopOpacity={light ? 0.16 : 1} />
          <stop offset="1" stopColor={light ? "#ffffff" : "#101c33"} stopOpacity={light ? 0.06 : 1} />
        </linearGradient>
      </defs>
      <rect width="40" height="40" rx="10" fill={`url(#bm-${id})`} />
      {light && <rect x="0.5" y="0.5" width="39" height="39" rx="9.5" fill="none" stroke="#ffffff" strokeOpacity="0.22" />}
      <g stroke="#ffffff" strokeLinecap="round" strokeWidth="3">
        <path d="M27.5 9.5v19" />
        <path d="M20 9.5v14" />
        <path d="M12.5 9.5v8" />
      </g>
      <rect x="9.5" y="25" width="6.5" height="6.5" rx="1.2" fill="#d4512f" />
    </svg>
  );
}

/** Mark + name. `light` for dark backgrounds. */
export function Wordmark({ tone = "ink", subtitle = true }: { tone?: "ink" | "light"; subtitle?: boolean }) {
  const light = tone === "light";
  return (
    <span className="flex min-w-0 items-center gap-2.5">
      <BrandMark tone={light ? "light" : "ink"} />
      <span className="min-w-0 leading-tight">
        <span className={`flex items-center gap-1.5 truncate text-[16px] font-bold ${light ? "text-white" : "text-ink"}`}>
          Expert Column
          <span className={`rounded px-1 py-px text-[10px] font-bold ${light ? "bg-white/15 text-white" : "bg-brand text-white"}`}>AI</span>
        </span>
        {subtitle && <span className={`block truncate text-[10.5px] ${light ? "text-white/60" : "text-muted"}`}>士業のための SEO 記事サービス</span>}
      </span>
    </span>
  );
}
